import { css } from '@emotion/react';
import { N40A } from '@atlaskit/theme/colors';
import { Breakpoint } from '../../hooks/use-container-breakpoints';
export const floatingContainerStyles = css`
  display: flex;
  flex-direction: column;
  padding: 0;
  > :not(:last-child) {
    border-bottom: 1px solid ${`var(--ds-border, ${N40A})`};
  }
`;
export const columnLayout = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${"var(--ds-space-050, 4px)"};
`;
export const promptPaddingStyles = css`
  padding: ${"var(--ds-space-150, 12px)"};
`;
export const footerTextStyles = breakpoint => css`
  color: ${"var(--ds-text-subtlest, #626F86)"};
  ${breakpoint <= Breakpoint.Small ? 'display: none' : ''}
`;
export const footerSectionStyles = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${"var(--ds-space-150, 12px)"};
  gap: ${"var(--ds-space-150, 12px)"};
`;
export const footerSectionSpacerStyles = css`
  flex-grow: 1;
`;